import DownloadControl from './DownloadControl';
import FileThumbnail from './FileThumbnail';
import LoadingIcon from './LoadingIcon';
import PermissionDots from './PermissionDots';
import SelectionCheckbox from './SelectionCheckbox';
import type { FileItemViewModel } from './types';

interface FileGridItemProps {
  id: string;
  view: string;
  file: any;
  roles: Array<number>;
  selected: boolean;
  visibility: Array<number>;
  groupColours: Array<any>;
  showDownloadMenu: boolean;
  downloadingSize: string;
  loadingCropTool: boolean;
  loadingModal: boolean;
  viewModel: FileItemViewModel;
  selectItem: (id: number) => void;
  downloadFile: (id: number, filename: string, size: string) => void;
  openCropTool: (id: number) => void;
  openModalImage: (id: number) => void;
  toggleActiveDownloadMenu: (id: string) => void;
}

const FileGridItem = ({
  id,
  view,
  file,
  roles,
  selected,
  visibility,
  groupColours,
  showDownloadMenu,
  downloadingSize,
  loadingCropTool,
  loadingModal,
  viewModel,
  selectItem,
  downloadFile,
  openCropTool,
  openModalImage,
  toggleActiveDownloadMenu,
}: FileGridItemProps) => (
  <div
    className={`relative fade-in
        ${
          view === 'small' &&
          ' w-[calc(50%-1rem)] lg:w-[calc(25%-1.5rem)] xl:w-[calc(20%-1.6rem)] mb-3'
        }
        ${
          view === 'medium' &&
          '  w-[calc(50%-1rem)] lg:w-[calc(33.3%-1.33rem)] mb-5'
        } 
        ${view === 'large' && ' w-full mb-10'} `}
  >
    <div
      className="group relative grid h-full content-end items-end overflow-hidden rounded-sm border border-border/25 bg-white/55 p-3 shadow-[var(--shadow-hairline)] transition-all hover:-translate-y-0.5 hover:border-text/45"
      key={file.ID}
    >
      <div
        className={`grid content-end overflow-hidden rounded-sm
                ${view === 'small' && 'h-[160px]'} 
                ${view === 'medium' && 'h-[290px] lg:h-[300px]'}
                ${view === 'large' && 'h-[180px] md:h-[500px]'}
                ${viewModel.isImage && 'cursor-pointer'}`}
        onClick={() => openModalImage(file.ID)}
      >
        <FileThumbnail
          file={file}
          mimeType={viewModel.mimeType}
          placeholder={viewModel.placeholder}
          isSvgOrAi={viewModel.isSvgOrAi}
          imageClassName="w-full h-full absolute top-0 left-0"
          placeholderClassName="w-full h-full object-scale-down absolute top-0 left-0"
        />

        {(roles.includes(0) || roles.includes(1)) && (
          <div className="absolute top-0 left-0 w-full h-full bg-text/0 transition-opacity group-hover:bg-text/35" />
        )}
        {loadingModal && (
          <div className="absolute top-3 left-3">
            <LoadingIcon
              className="w-[20px] h-[20px] text-accent animate-spin"
              stroke="white"
              fill="white"
            />
          </div>
        )}
        {visibility.length > 1 && (
          <div className="relative flex-wrap content-center w-full gap-1 mr-5">
            {(roles.includes(0) || roles.includes(1)) && (
              <div className="relative flex gap-1">
                {groupColours.length > 0 && (
                  <PermissionDots
                    groupColours={groupColours}
                    dotClassName="w-3 h-3 border border-white rounded-full group/groups cursor-pointer transition-all relative"
                    tooltipClassName="hidden group-hover/groups:block absolute bottom-4 px-2 py-0.5 rounded-sm bg-text text-white text-xs -left-1 shadow"
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {(roles.includes(0) || roles.includes(1)) && (
        <SelectionCheckbox
          selected={selected}
          onClick={() => selectItem(file.ID)}
          uncheckedClassName="border-white/80 hidden group-hover:block bg-white/70"
          className="absolute right-3 top-3 inline-block grid h-5 w-5 cursor-pointer content-center rounded-sm border p-0.5"
        />
      )}
    </div>

    <div className="mt-2 flex items-center justify-between px-1">
      <div
        className={` ${
          view === 'small' ? 'max-w-[120px]' : 'max-w-[70%]'
        } relative flex items-center justify-start gap-2`}
      >
        <p
          title={file.file}
          className={`${
            view === 'small' ? 'text-xs' : 'text-sm '
          } relative overflow-hidden font-semibold text-text filename-ellipsis`}
        >
          {file.file}
        </p>
        <DownloadControl
          id={id}
          file={file}
          dimensions={viewModel.dimensions}
          isImage={viewModel.isImage}
          showDownloadMenu={showDownloadMenu}
          downloadingSize={downloadingSize}
          loadingCropTool={loadingCropTool}
          menuClassName="brand-panel absolute bottom-10 left-3 w-[150px] py-1"
          iconClassName="download-button inline-block h-6 w-6 cursor-pointer bg-opacity-50 p-[3px] stroke-default transition-colors hover:stroke-accent"
          iconWrapperClassName="flex items-center gap-2 cursor-pointer hover:opacity-80 group"
          downloadFile={downloadFile}
          openCropTool={openCropTool}
          toggleActiveDownloadMenu={toggleActiveDownloadMenu}
        />
      </div>
      <div>
        <p
          className={`relative text-muted text-xs
        ${view === 'small' ? 'text-xs' : 'text-sm'}
       `}
        >
          {viewModel.formattedSize}
        </p>
      </div>
    </div>
  </div>
);

export default FileGridItem;
